import React from 'react'

interface BarIconProps {
  className?: string;
}

const BarIcon: React.FC<BarIconProps> = ({ className }) => {
  return (
    <svg width="24" height="24" className={className}viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M21 3V5L13 14V19H18V21H6V19H11V14L3 5V3H21ZM5.66 5L7.43 7H16.57L18.35 5H5.66Z" fill="#1E293B"/>
    </svg>
    
  )
}

export default BarIcon

